import { AdminRecordsLoading } from '@/views/admin-records/admin-records.loading';

export default AdminRecordsLoading;
